// extracted by mini-css-extract-plugin
export default {"container":"An-z","bubbleNav":"Bn-z","graphic":"Cn-z","contact":"Dn-z"};